const prefix = "USER_";

export const CHANGE_PASSWORD = prefix + "CHANGE_PASSWORD";
export const SIGN_IN = prefix + "SIGN_IN";
export const SIGN_IN_ATTEMPT_MFA_CHALLENGE = prefix + "SIGN_IN_ATTEMPT_MFA_CHALLENGE";
export const SIGN_OUT = prefix + "SIGN_OUT";
export const WIDGETS_GET = prefix + "WIDGETS_GET";
export const WIDGETS_SAVE = prefix + "WIDGETS_SAVE";